<!-- documents.component.html -->
<div class="documents-container" *ngIf="!showErrorMessage">

  <div class="logo-section" *ngIf="logoUrl">
    <img [src]="logoUrl" alt="Company Logo" class="company-logo">
  </div>

  <div class="document-sections">
    <!-- Left Side: DRAFT, NOT_SUBMITTED, and REJECTED -->
    <div class="left-side card">
      <div class="card-header">
        <h2>Documents to Upload</h2>
      </div>
      
      <!-- Show message if there are no documents -->
      <div *ngIf="draftOrNotSubmittedDocuments.length === 0" class="empty-state">
        <mat-icon>check_circle</mat-icon>
        <p>You have uploaded all required documents</p>
      </div>
      
      <div *ngFor="let doc of draftOrNotSubmittedDocuments" class="document-item">
        <div class="document-header" (click)="toggleUpload(doc.id)">
          <div class="title-container">
            <h3>{{ doc?.document?.uploadTitle }}</h3>
            <mat-icon *ngIf="doc.status === 'REJECTED'" class="danger-icon">error</mat-icon>
          </div>
          <mat-icon class="toggle-icon">{{ toggleStates[doc.id] ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        
        <div *ngIf="toggleStates[doc.id]" class="upload-section">
          <p [innerHTML]="doc?.document?.uploadDescription"></p>

          <!-- Show Rejection Info if Document is Rejected -->
          <div *ngIf="doc.status === 'REJECTED'" class="rejection-info">
            <div class="rejection-header">
              <mat-icon>warning</mat-icon>
              <span>Document Rejected</span>
            </div>
            <p *ngIf="doc.rejectionReason" class="rejection-reason">
              {{ doc.rejectionReason }}
            </p>
          </div>

          <div class="file-upload-container">
            <div class="file-input-wrapper">
              <input #fileInput type="file" (change)="onFileSelected($event, doc.id)"
                    accept=".xls,.xlsx,.pdf,.doc,.docx,image/*" id="file-{{doc.id}}" />
              <label for="file-{{doc.id}}" class="file-select-button">
                <mat-icon>attach_file</mat-icon>
                <span>Select File</span>
              </label>
            </div>

            <!-- Preview Card for Selected File -->
            <div *ngIf="selectedFiles[doc.id]" class="preview-card">
              <div class="preview-header">
                <mat-icon>{{ getFileIcon(selectedFiles[doc.id]?.name) }}</mat-icon>
                <span class="file-name">{{ selectedFiles[doc.id]?.name }}</span>
                <button (click)="removeFile(doc.id, fileInput)" class="remove-button">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <button mat-flat-button color="primary" 
          *ngIf="selectedFiles[doc.id]" 
          (click)="uploadDocument(doc)"
          [disabled]="uploadingStates[doc.id]">
            <div style="display: flex;justify-content: center;" *ngIf="!uploadingStates[doc.id]">
              <mat-icon>cloud_upload</mat-icon>
              <span style="margin-top: 3px;">Upload Document</span>
            </div>
            <div class="uploading-state" *ngIf="uploadingStates[doc.id]">
              <mat-spinner diameter="20"></mat-spinner>
              Uploading...
            </div>
          </button>
        </div>
      </div>
    </div>

    <div class="divider"></div>
    
    <!-- Right Side: SUBMITTED and APPROVED -->
    <div class="right-side card">
      <div class="card-header">
        <h2>Uploaded Documents</h2>
      </div>
      
      <!-- Show message if there are no submitted documents -->
      <div *ngIf="submittedDocuments.length === 0" class="empty-state">
        <mat-icon>upload</mat-icon>
        <p>No documents uploaded yet</p>
      </div>
      
      <div *ngFor="let doc of submittedDocuments" class="document-item" [ngClass]="'status-' + doc.status.toLowerCase()">
        <div class="document-content">
          <!-- Texts on the Left -->
          <div class="text-section">
            <h3>{{ doc?.document?.uploadTitle }}</h3>
            <div class="status-badge" [ngClass]="'status-' + doc.status.toLowerCase()">
              <mat-icon>{{ getStatusIcon(doc.status) }}</mat-icon>
              <span>{{ doc.status | titlecase }}</span>
            </div>
          </div>

          <!-- Image or Icon on the Right -->
          <app-image-section [doc]="doc"></app-image-section>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Error State -->
<div *ngIf="showErrorMessage" class="error-container">
  <h1>No documents available</h1>
  <p>{{showErrorMessage}}</p>
  <img src="../../../assets/images/backgrounds/noDocuments.jpg" alt="No Financial-aid Application Available" />
  <button mat-raised-button color="primary" type="button">Go back</button>
</div>